import React, {Suspense} from "react";
import {BrowserRouter as Router, Outlet} from "react-router-dom";

const PagePreloader = () => <div>test</div>;

export const ProjectIndex: React.FC = () => (
	<Router basename={"/"}>
		<Suspense fallback={<PagePreloader />}>
			<Outlet />
		</Suspense>
	</Router>
);

// tslint:disable-next-line:fractal-control-default-export
export default ProjectIndex;
